export const environment = {
    production: false,
    ApiUrl: 'https://api.skilltrial.com/api'
};
